import React, { useEffect, useState, useRef } from "react";

const testimoniosData = [
  { nombre: "Camila Torres", reseña: "¡Me encantó! Llegó rápido y es aún más bonito en persona. Lo recomiendo totalmente." },
  { nombre: "David Ramírez", reseña: "Atención excelente y producto de gran calidad. Volveré a comprar sin duda." },
  { nombre: "Laura Pérez", reseña: "Todo perfecto. Me ayudaron con una duda antes de comprar y el envío fue rápido." },
  { nombre: "Andrés Gómez", reseña: "La lámpara es una obra de arte. El diseño 3D está súper bien hecho. ¡Gracias!" },
  { nombre: "María Castillo", reseña: "Excelente servicio, súper responsables y muy atentos. Me encantó el resultado." },
  { nombre: "Santiago López", reseña: "La mejor compra que he hecho este año. 10/10." },
  { nombre: "Ana Rodríguez", reseña: "El producto superó mis expectativas. Se nota el trabajo detallado." },
  { nombre: "Felipe Martínez", reseña: "Llegó justo a tiempo para un regalo especial. ¡Gracias por todo!" },
  { nombre: "Isabela Ruiz", reseña: "Espectacular diseño y calidad. ¡Vale cada peso!" },
  { nombre: "Carlos Herrera", reseña: "El empaque, la atención, el diseño… todo impecable." },
  { nombre: "Juliana Méndez", reseña: "Se nota el amor por el diseño. Me fascinó." },
  { nombre: "Mateo Vargas", reseña: "Muy recomendado. La calidad es excelente y el envío rápido." },
  { nombre: "Valentina Gil", reseña: "¡Estoy feliz con mi compra! Muchas gracias por todo." },
  { nombre: "Sebastián Peña", reseña: "Lo compré como regalo y fue un éxito total." },
  { nombre: "Daniela Franco", reseña: "Una atención muy profesional. El diseño quedó hermoso." },
  { nombre: "Julián Cortés", reseña: "Fácil de pedir, rápido de recibir, y mejor de lo que imaginaba." },
  { nombre: "Paula Acosta", reseña: "Es mi segundo pedido y ambos han sido perfectos." },
  { nombre: "Tomás Morales", reseña: "¡Qué talento! Muy satisfecho con la compra." },
];

function shuffleArray(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

const TestimoniosDeslizantes = () => {
  const [testimonios, setTestimonios] = useState([]);
  const scrollRef = useRef(null);
  const intervalRef = useRef(null);
  const isUserHolding = useRef(false);

  useEffect(() => {
    setTestimonios(shuffleArray(testimoniosData));
  }, []);

  const startAutoScroll = () => {
    stopAutoScroll(); // evitar múltiples intervalos

    const container = scrollRef.current;
    if (!container) return;

    let scrollAmount = container.scrollLeft;

    intervalRef.current = setInterval(() => {
      if (!isUserHolding.current) {
        scrollAmount += 2;
        container.scrollLeft = scrollAmount;

        if (scrollAmount >= container.scrollWidth - container.clientWidth) {
          scrollAmount = 0;
        }
      }
    }, 26);
  };

  const stopAutoScroll = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  // Controlar presión del usuario
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleHoldStart = () => {
      isUserHolding.current = true;
    };

    const handleHoldEnd = () => {
      isUserHolding.current = false;
    };

    // Escuchar presión táctil o click
    container.addEventListener("mousedown", handleHoldStart);
    container.addEventListener("mouseup", handleHoldEnd);
    container.addEventListener("mouseleave", handleHoldEnd);
    container.addEventListener("touchstart", handleHoldStart, { passive: true });
    container.addEventListener("touchend", handleHoldEnd);
    container.addEventListener("touchcancel", handleHoldEnd);

    return () => {
      container.removeEventListener("mousedown", handleHoldStart);
      container.removeEventListener("mouseup", handleHoldEnd);
      container.removeEventListener("mouseleave", handleHoldEnd);
      container.removeEventListener("touchstart", handleHoldStart);
      container.removeEventListener("touchend", handleHoldEnd);
      container.removeEventListener("touchcancel", handleHoldEnd);
    };
  }, []);

  useEffect(() => {
    startAutoScroll();
    return stopAutoScroll;
  }, []);

  return (
    <div
      style={{
        width: "100%",
        padding: "40px 20px",
        overflow: "hidden",
        position: "relative",
        touchAction: "none", // impide scroll en móviles
      }}
    >
      <h2
        style={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "24px",
          marginBottom: "30px",
          color: "white",
        }}
      >
        Testimonios de Nuestros Clientes
      </h2>

      <div
        ref={scrollRef}
        style={{
          display: "flex",
          gap: "20px",
          overflowX: "hidden", // ya no visible ni manipulable
          scrollBehavior: "smooth",
          pointerEvents: "auto",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {testimonios.map((testimonio, index) => (
          <div
            key={index}
            style={{
              minWidth: "250px",
              maxWidth: "250px",
              borderRadius: "20px",
              backgroundColor: "white",
              padding: "20px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              flexShrink: 0,
              userSelect: "none",
              touchAction: "none",
            }}
          >
            <div style={{ color: "#FFD700", fontSize: "20px", marginBottom: "10px" }}>
              ★★★★★
            </div>
            <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "5px", color: "black" }}>
              {testimonio.nombre}
            </div>
            <div style={{ fontSize: "12px", color: "green", marginBottom: "5px" }}>
              ✅ Usuario Verificado
            </div>
            <div style={{ fontSize: "12px", color: "gray", marginBottom: "10px" }}>
              {new Date().toLocaleDateString()}
            </div>
            <div style={{ fontSize: "14px", color: "#333" }}>{testimonio.reseña}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimoniosDeslizantes;
